// extracted by mini-css-extract-plugin
export var anchor = "_5d-0";
export var discard = "_5d-4";
export var muiTooltipTooltip = "_5d-6";
export var notificationBar = "_5d-3";
export var saveButtonHoverSlotWrapper = "_5d-5";
export var show = "_5d-2";
export var spacer = "_5d-1";